export const meta = {
    keyExpr: 'kod_spr_smet',
    columns: [
        {
            name: 'kod_smet',
            caption: 'Код',
            dataField: 'kod_smet',
            allowEditing: true,
            width: 250,
            index: 1,
            visible: false,
        },
        {
            name: 'cost_items',
            caption: 'Статьи затрат',
            dataField: 'cost_items',
            allowEditing: false,
            width: 250,
            index: 5,
            visible: true,
        },
        {
            name: 'kod_parent',
            caption: 'kod_parent',
            dataField: 'kod_parent',
            allowEditing: false,
            index: 4,
            width: 450,
            visible: false,
        },
    ],
    api: {
        select: 'mped./mped/calculation-string-algorithm-treelist-select/get',
    },
    viewId: 'calculation-string-algorithm',
    parentIdExpr: 'kod_parent',
};

export const gridMeta = {
    keyExpr: 'kod_spr_smet',
    scrollingMode: 'standart',
    maxWidth: 'max-w-96',
    columns: [
        {
            name: 'kod_smet',
            caption: 'Код',
            dataField: 'kod_smet',
            allowEditing: true,
            index: 1,
            width: 70,
            visible: true,
            fixed: true,
        },
        {
            name: 'name',
            caption: 'Статья сметы',
            dataField: 'name',
            allowEditing: true,
            index: 1,
            visible: true,
            fixed: true,
        },
    ],
    api: {
        select: 'mped./mped/calculation-string-algorithm-grid-select/get',
    },
};
